<template>
    <v-card flat class="ma-5">
        <timeline :setup="setup"></timeline>
    </v-card>
</template>

<script>
import Timeline from '@/components/Timeline'

export default {
    name: 'detail-tab-timeline',
    props: ['name'],
    components: {
        Timeline
    },
    data: function () {
        return {
            setup: {
                fromDemand: false,
                isEmployee: true,
                showAdd: false,
                showUpdate: true,
                timeline: {
                    className: 'Employee'
                }
            }
        }
    }
}
</script>
